import { useEffect } from 'react';
import type { SurrendersParams, Surrenders } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';
import { useOptionalAuthenticatedMonolithUser } from 'src/hooks/use-monolith-user';

type HookConfig = {
  params: SurrendersParams;
};

export function useSurrenders({ params }: HookConfig) {
  const reports = useAxios(
    (axios, baseConfig, params: SurrendersParams) =>
      axios.request<Surrenders>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.monolithApiUrl}/surrender/getSurrenderRequests`,
        method: 'GET',
        params,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    reports.execute(params);
    // oxlint-disable-next-line exhaustive-deps
  }, [params]);

  return reports;
}

export type SurrendersRequest = ReturnType<typeof useSurrenders>;

export function useOptionalSurrenders({ params }: HookConfig) {
  const monolithUser = useOptionalAuthenticatedMonolithUser();
  const isShipper = monolithUser?.isShipper;

  const reports = useAxios(
    (axios, baseConfig, params: SurrendersParams) =>
      axios.request<Surrenders>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.monolithApiUrl}/surrender/getSurrenderRequests`,
        method: 'GET',
        params,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!isShipper) return;
    reports.execute(params);
    // oxlint-disable-next-line exhaustive-deps
  }, [params]);

  if (!isShipper) return;

  return reports;
}

export type OptionalSurrendersRequest = ReturnType<
  typeof useOptionalSurrenders
>;
